import { React, moment } from 'Imports';
import { VehicleCameraPairingResponse } from '$Generated/api';
import { isEncompass } from '$Utilities/integrationPlatform';
import * as DateFormatter from '$Components/Shared/DateFormatter';

const styles = require('./RequestVideoHeader.scss') as {
    container: string;
    containerEncompass: string;
    field: string;
    label: string;
    value: string;
    cameraValueRow: string;
    statusIndicator: string;
    onlineIndicator: string;
    offlineIndicator: string;
    onlineText: string;
    offlineText: string;
};

interface IRequestVideoHeaderProps {
    pairing: VehicleCameraPairingResponse;
    selectedDate?: Date;
    requestStartDate?: Date;
    requestEndDate?: Date;
    // Overrides the pairing's (possibly stale) onlineStatus once the preview polling detects the camera
    // has disconnected mid-load, so the header doesn't keep showing "Online" after the fact.
    isCameraDisconnected?: boolean;
}

export const RequestVideoHeader = (props: IRequestVideoHeaderProps) => {
    const { pairing, selectedDate, requestStartDate, requestEndDate } = props;
    const isOnline = !props.isCameraDisconnected && pairing.cameraDevice?.onlineStatus?.toLowerCase() === 'online';
    const containerClass = isEncompass
        ? `${styles.container} ${styles.containerEncompass}`
        : styles.container;

    return (
        <div className={containerClass}>
            <div className={styles.field}>
                <div className={styles.label}>Camera</div>
                <div className={styles.cameraValueRow}>
                    <span className={styles.value}>{pairing.cameraDevice?.serialNumber ?? '\u2014'}</span>
                    <div className={`${styles.statusIndicator} ${isOnline ? styles.onlineIndicator : styles.offlineIndicator}`}>
                        <span className={isOnline ? styles.onlineText : styles.offlineText}>{isOnline ? 'Online' : 'Offline'}</span>
                    </div>
                </div>
            </div>
            <div className={styles.field}>
                <div className={styles.label}>Vehicle</div>
                <div className={styles.value}>{pairing.vehicle?.name ?? '\u2014'}</div>
            </div>
            <div className={styles.field}>
                <div className={styles.label}>Date Selected</div>
                <div className={styles.value}>{selectedDate ? DateFormatter.date(moment(selectedDate)) : '\u2014'}</div>
            </div>
            <div className={styles.field}>
                <div className={styles.label}>Recall Time ({DateFormatter.getTimezoneString()})</div>
                <div className={styles.value}>
                    {requestStartDate && requestEndDate
                        ? `${moment(requestStartDate).tz(moment.tz.guess()).format('hh:mm:ss A')} - ${moment(requestEndDate).tz(moment.tz.guess()).format('hh:mm:ss A')}`
                        : '\u2014'}
                </div>
            </div>
        </div>
    );
};

export default RequestVideoHeader;
